<template>
  <b-modal 
    id="confirm"
    ref="confirm"
    :hide-header="true"
    :hide-header-close="true"
    ok-title="Yes"
    cancel-title="Cancel"
    size="lg"
    @hide="onHide"
    @ok="onOk"
    @cancel="onCancel">
    <b-container class="confirm_container">
      <b-row>
        <b-col 
          class="confirm_image" 
          cols="1">
          <span>
            <i class="confirm fas fa-exclamation-triangle" />
          </span>
        </b-col>
        <b-col cols="1" />
        <b-col 
          class="confirm_text" 
          cols="10">
          <span
            class="text-break"
            style="white-space: pre-line">
            {{ message }}
          </span>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
  export default {
    name: "Confirm",
    data() {
      return {
        show: false,
        message: null,
        resolve: null,
      }
    },
    methods: {
      open(message) {
        if (!this.$parent) {
          this.$mount()
          document.body.className = document.body.className.replace("modal-open","")
          document.body.appendChild(this.$el)
        }
        return new Promise(resolve => {
          this.message = message
          this.resolve = resolve
          this.$refs.confirm.show()
        })
      },
      onOk() {
        this.resolve(true)
      },
      onCancel() {
        this.resolve(false)
      },
      onHide(evt) {
        if (evt.trigger === 'esc' || evt.trigger === 'header-close') {
          this.resolve(false)
        }
      },
    },
  }
</script>

<style scoped>
  i.confirm {
    padding-right: 2rem;
    color: #fad100;
    font-size: 30px;
  }

  .confirm_container {
    display: flex;
    background: #fff;
  }

  .confirm_text {
    flex: 1 0 50%;
    padding: 10px;
    max-height: 600px;
    overflow-y: scroll;
  }

  .confirm_image {
    display: flex;
    flex: 1 0 50%;
    align-items: center;
  }

</style>
